const homeAreaOptions=[
  {
    value: "Amagansett",
    label: "Amagansett",
  },
  {
    value: "Montauk",
    label: "Montauk",
  },
  {
    value: "Bridgehampton",
    label: "Bridgehampton",
  },
  {
    value: "East Hampton",
    label: "East Hampton",
  },
  {
    value: "Hampton Bays",
    label: "Hampton Bays",
  },
  {
    value: "Sagaponack",
    label: "Sagaponack",
  },
  {
    value: "Quogue",
    label: "Quogue",
  },
  {
    value: "Wainscott",
    label: "Wainscott",
  },
  {
    value: "Water Mill",
    label: "Water Mill",
  },
  {
    value: "Sag Harbor",
    label: "Sag Harbor",
  },
  {
    value: "Westhampton",
    label: "Westhampton",
  },
  {
    value: "Southampton",
    label: "Southampton",
  },
  {
    value: "Quiogue",
    label: "Quiogue",
  },
  {
    value: "North Haven",
    label: "North Haven",
  },
  {
    value: "Flanders",
    label: "Flanders",
  },
  {
    value: "Shelter Island",
    label: "Shelter Island",
  },
]
const areaOptions = [
  {
    value: "Amagansett",
    label: "Amagansett",
  },
  {
    value: "Montauk",
    label: "Montauk",
  },
  {
    value: "Bridgehampton",
    label: "Bridgehampton",
  },
  {
    value: "East Hampton",
    label: "East Hampton",
  },
  {
    value: "Hampton Bays",
    label: "Hampton Bays",
  },
  {
    value: "Sagaponack",
    label: "Sagaponack",
  },
  {
    value: "Quogue",
    label: "Quogue",
  },
  {
    value: "Wainscott",
    label: "Wainscott",
  },
  {
    value: "Water Mill",
    label: "Water Mill",
  },
  {
    value: "Sag Harbor",
    label: "Sag Harbor",
  },
  {
    value: "Westhampton",
    label: "Westhampton",
  },
  {
    value: "Southampton",
    label: "Southampton",
  },
  {
    value: "Quiogue",
    label: "Quiogue",
  },
  {
    value: "North Haven",
    label: "North Haven",
  },
];
const subAreaOptions=  [
  {
    value: "Amagansett Dunes",
    label: "Amagansett Dunes",
  },
  {
    value: "Amagansett Lanes",
    label: "Amagansett Lanes",
  },
  {
    value: "Amagansett North",
    label: "Amagansett North",
  },
  {
    value: "Amagansett South",
    label: "Amagansett South",
  },
  {
    value: "Napeague",
    label: "Napeague",
  },
  {
    value: "East Hampton Northwest",
    label: "East Hampton Northwest",
  },
  {
    value: "East Hampton South",
    label: "East Hampton South",
  },
  {
    value: "East Hampton Village",
    label: "East Hampton Village",
  },
  {
    value: "East Hampton Village Fringe",
    label: "East Hampton Village Fringe",
  },
  {
    value: "3-Mile Harbor",
    label: "3-Mile Harbor",
  },
  {
    value: "Springs",
    label: "Springs",
  },
  {
    value: "Barnes",
    label: "Barnes",
  },
  {
    value: "Southampton North",
    label: "Southampton North",
  },
  {
    value: "Southampton South",
    label: "Southampton South",
  },
  {
    value: "Southampton Village",
    label: "Southampton Village",
  },
  {
    value: "Southampton Village Fringe",
    label: "Southampton Village Fringe",
  },
  {
    value: "North Sea",
    label: "North Sea",
  },
  {
    value: "Flying Point",
    label: "Flying Point",
  },
  {
    value: "Shinnecock",
    label: "Shinnecock",
  },
  {
    value: "Noyac",
    label: "Noyac",
  },
  {
    value: "Tuckahoe",
    label: "Tuckahoe",
  },
  {
    value: "Old Town Area",
    label: "Old Town Area",
  },
  {
    value: "Culloden",
    label: "Culloden",
  },
  {
    value: "Ditch Plains",
    label: "Ditch Plains",
  },
  {
    value: "Hither Hills",
    label: "Hither Hills",
  },
  {
    value: "East Lake",
    label: "East Lake",
  },
  {
    value: "Hampton Bays North",
    label: "Hampton Bays North",
  },
  {
    value: "Hampton Bays South",
    label: "Hampton Bays South",
  },
  {
    value: "Quogue North",
    label: "Quogue North",
  },
  {
    value: "Quogue South",
    label: "Quogue South",
  },
  {
    value: "Quogue Village",
    label: "Quogue Village",
  },
  {
    value: "Sag Harbor Village",
    label: "Sag Harbor Village",
  },
  {
    value: "Sag Harbor Village Fringe",
    label: "Sag Harbor Village Fringe",
  },
  {
    value: "Bridgehampton North",
    label: "Bridgehampton North",
  },
  {
    value: "Bridgehampton South",
    label: "Bridgehampton South",
  },
  {
    value: "Sagaponack North",
    label: "Sagaponack North",
  },
  {
    value: "Sagaponack South",
    label: "Sagaponack South",
  },
  {
    value: "Wainscott North",
    label: "Wainscott North",
  },
  {
    value: "Wainscott South",
    label: "Wainscott South",
  },
  {
    value: "Watermill North",
    label: "Watermill North",
  },
  {
    value: "Watermill South",
    label: "Watermill South",
  },
  {
    value: "Westhampton Beach",
    label: "Westhampton Beach",
  },
  {
    value: "Westhampton Dunes",
    label: "Westhampton Dunes",
  },
  {
    value: "Westhampton North",
    label: "Westhampton North",
  },
  {
    value: "Westhampton South",
    label: "Westhampton South",
  },
  {
    value: "East Quogue",
    label: "East Quogue",
  },
  {
    value: "North Haven",
    label: "North Haven",
  },
  {
    value: "Flanders",
    label: "Flanders",
  },
  {
    value: "Quogue",
    label: "Quogue",
  },
  {
    value: "Shelter Island",
    label: "Shelter Island",
  },
  {
    value: "Shelter Island Heights",
    label: "Shelter Island Heights",
  },
  {
    value: "Remsenburg",
    label: "Remsenburg",
  },
]
// const subAreaOptions=  [
//   {
//     value: "East Lake",
//     label: "East Lake",
//   },
//   {
//     value: "Culloden",
//     label: "Culloden",
//   },
//   {
//     value: "Ditch Plains",
//     label: "Ditch Plains",
//   },
//   {
//     value: "Surfside",
//     label: "Surfside",
//   },
//   {
//     value: "Shepherds Neck",
//     label: "Shepherds Neck",
//   },
//   {
//     value: "Hither Hills",
//     label: "Hither Hills",
//   },
//   {
//     value: "Napeague",
//     label: "Napeague",
//   },
//   {
//     value: "Amagansett North",
//     label: "Amagansett North",
//   },
//   {
//     value: "Amagansett South",
//     label: "Amagansett South",
//   },
//   {
//     value: "Barnes",
//     label: "Barnes",
//   },
//   {
//     value: "3-Mile Harbor",
//     label: "3-Mile Harbor",
//   },
//   {
//     value: "Wainscott North",
//     label: "Wainscott North",
//   },
//   {
//     value: "Wainscott South",
//     label: "Wainscott South",
//   },
//   {
//     value: "Sagaponack North",
//     label: "Sagaponack North",
//   },
//   {
//     value: "Sagaponack South",
//     label: "Sagaponack South",
//   },
//   {
//     value: "Bridgehampton North",
//     label: "Bridgehampton North",
//   },
//   {
//     value: "Bridgehampton South",
//     label: "Bridgehampton South",
//   },
//   {
//     value: "Watermill North",
//     label: "Watermill North",
//   },
//   {
//     value: "Watermill South",
//     label: "Watermill South",
//   },
//   {
//     value: "Flying Point",
//     label: "Flying Point",
//   },
//   {
//     value: "Fordune Area",
//     label: "Fordune Area",
//   },
//   {
//     value: "Old Town Area",
//     label: "Old Town Area",
//   },
//   {
//     value: "North Sea",
//     label: "North Sea",
//   },
//   {
//     value: "Tuckahoe",
//     label: "Tuckahoe",
//   },
//   {
//     value: "Shinnecock",
//     label: "Shinnecock",
//   },
//   {
//     value: "Hampton Bays North",
//     label: "Hampton Bays North",
//   },
//   {
//     value: "Hampton Bays South",
//     label: "Hampton Bays South",
//   },
//   {
//     value: "Quogue Village",
//     label: "Quogue Village",
//   },
//   {
//     value: "Quogue North",
//     label: "Quogue North",
//   },
//   {
//     value: "Westhampton North",
//     label: "Westhampton North",
//   },
//   {
//     value: "Other",
//     label: "Other",
//   },
//   {
//     value: "Sag Harbor Village",
//     label: "Sag Harbor Village",
//   },
//   {
//     value: "Noyac",
//     label: "Noyac",
//   },
//   {
//     value: "Southampton Village Fringe",
//     label: "Southampton Village Fringe",
//   },
//   {
//     value: "Remsenburg",
//     label: "Remsenburg",
//   },
//   {
//     value: "North Fork",
//     label: "North Fork",
//   },
//   {
//     value: "Westhampton South",
//     label: "Westhampton South",
//   },
//   {
//     value: "Southampton North",
//     label: "Southampton North",
//   },
//   {
//     value: "Southampton South",
//     label: "Southampton South",
//   },
//   {
//     value: "Amagansett Dunes",
//     label: "Amagansett Dunes",
//   },
//   {
//     value: "Amagansett Lanes",
//     label: "Amagansett Lanes",
//   },
//   {
//     value: "East Hampton South",
//     label: "East Hampton South",
//   },
//   {
//     value: "Sag Harbor Village Fringe",
//     label: "Sag Harbor Village Fringe",
//   },
//   {
//     value: "Quogue South",
//     label: "Quogue South",
//   },
// ]
const basementOptions = [
  {
    value: "Partial",
    label: "Partial",
  },
  {
    value: "Crawl",
    label: "Crawl",
  },
  {
    value: "Full",
    label: "Full",
  },
  {
    value: "Finished",
    label: "Finished",
  },
  // {
  //   value: "N/A",
  //   label: "N/A",
  // },
];
const bathroomOptions = [
  {
    value: "1+",
    label: "1",
  },
  {
    value: "2+",
    label: "2",
  },
  {
    value: "3+",
    label: "3",
  },
  {
    value: "4+",
    label: "4",
  },
  {
    value: "5+",
    label: "5",
  },
  {
    value: "6+",
    label: "6",
  },
  {
    value: "7+",
    label: "7",
  },
  {
    value: "8+",
    label: "8",
  },
  {
    value: "9+",
    label: "9",
  },
  {
    value: "10+",
    label: "10",
  },
  {
    value: "11+",
    label: "11",
  },
  {
    value: "12+",
    label: "12",
  },
];
const ACOptions = [
  {
    value: "Central Air",
    label: "Central Air",
  },
  {
    value: "Wall Units",
    label: "Wall Units",
  },
  // {
  //   value: "N/A",
  //   label: "N/A",
  // },
];
const bedRoomsOptions = [
  {
    value: "1+",
    label: "1",
  },
  {
    value: "2+",
    label: "2",
  },
  {
    value: "3+",
    label: "3",
  },
  {
    value: "4+",
    label: "4",
  },
  {
    value: "5+",
    label: "5",
  },
  {
    value: "6+",
    label: "6",
  },
  {
    value: "7+",
    label: "7",
  },
  {
    value: "8+",
    label: "8",
  },
  {
    value: "9+",
    label: "9",
  },
  {
    value: "10+",
    label: "10",
  },
  {
    value: "11+",
    label: "11",
  },
  {
    value: "12+",
    label: "12",
  },
];
const fireplaceOptions = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5+",
    label: "5+",
  },
];
const garageOptions = [
  {
    value: "Attached",
    label: "Attached",
  },
  {
    value: "Detached",
    label: "Detached",
  },
  {
    value: "No",
    label: "No",
  },
];
const heatingOptions = [
  {
    value: "Oil Hot Air",
    label: "Oil Hot Air",
  },
  {
    value: "Oil Hot Water",
    label: "Oil Hot Water",
  },
  {
    value: "Gas Hot Water",
    label: "Gas Hot Water",
  },
  {
    value: "Gas Hot Air",
    label: "Gas Hot Air",
  },
  {
    value: "Electric",
    label: "Electric",
  },
  {
    value: "Other",
    label: "Other",
  },
];
const petsOptions = [
  {
    value: "Pets allowed w/ Extra Deposit",
    label: "Pets allowed w/ Extra Deposit",
  },
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
];
const poolOptions = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "Heated Pool",
    label: "Heated Pool",
  },
  {
    value: "No",
    label: "No",
  },
];
const storyOptions = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
];
const styleOptions = [
  {
    value: "Traditional",
    label: "Traditional",
  },
  {
    value: "Contemporary",
    label: "Contemporary",
  },
  {
    value: "Beach Cottage",
    label: "Beach Cottage",
  },
  {
    value: "Victorian",
    label: "Victorian",
  },
  {
    value: "Post Modern",
    label: "Post Modern",
  },
  {
    value: "Farmhouse",
    label: "Farmhouse",
  },
  {
    value: "Ranch",
    label: "Ranch",
  },
  {
    value: "Apartment",
    label: "Apartment",
  },
  {
    value: "Condo/Co-op",
    label: "Condo/Co-op",
  },
  {
    value: "Chateau",
    label: "Chateau",
  },
  {
    value: "Saltbox",
    label: "Saltbox",
  },
  {
    value: "Modern",
    label: "Modern",
  },
  {
    value: "Cape",
    label: "Cape",
  },
  {
    value: "Other",
    label: "Other",
  },
];
const tennisOptions = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "Har-Tru",
    label: "Har-Tru",
  },
  {
    value: "No",
    label: "No",
  },
];
const waterfrontOptions = [
  {
    value: "Waterview",
    label: "Waterview",
  },
  {
    value: "Waterfront",
    label: "Waterfront",
  },
  {
    value: "Oceanfront",
    label: "Oceanfront",
  },
  {
    value: "Bayfront",
    label: "Bayfront",
  },
  {
    value: "Oceanview",
    label: "Oceanview",
  },
  // {
  //   value: "N/A",
  //   label: "N/A",
  // },
];
const leaseTermOptions = [
  {
    value: "<1 Year",
    label: "<1 Year",
  },
  {
    value: "1-5 Years",
    label: "1-5 Years",
  },
  {
    value: "6-10 Years",
    label: "6-10 Years",
  },
  {
    value: ">10 Years",
    label: ">10 Years",
  },
  {
    value: "All Terms Considered",
    label: "All Terms Considered",
  },
];
const mainAmenityOptions = [
  {
    value: "Village Location",
    label: "Village Location",
  },
  {
    value: "Quiet",
    label: "Quiet",
  },
  // {
  //   value: "Private",
  //   label: "Private",
  // },
  {
    value: "New Construction",
    label: "New Construction",
  },
  {
    value: "Charming",
    label: "Charming",
  },
  {
    value: "Downstairs Master",
    label: "Downstairs Master",
  },
  // {
  //   value: "Tennis",
  //   label: "Tennis",
  // },
  // {
  //   value: "Waterfront/Waterview",
  //   label: "Waterfront/Waterview",
  // },
  {
    value: "South-of Highway",
    label: "South-of Highway",
  },
  // {
  //   value: "Fixerupper",
  //   label: "Fixerupper",
  // },
  {
    value: "Convenient",
    label: "Convenient",
  },
  {
    value: "Near to beach",
    label: "Near to beach",
  },
  {
    value: "Near to village",
    label: "Near to village",
  },  
  // {
  //   value: "Furnished",
  //   label: "Furnished",
  // },
  // {
  //   value: "Wireless Web",
  //   label: "Wireless Web",
  // },
  {
    value: "Child Safety Fence",
    label: "Child Safety Fence",
  },
  {
    value: "Handicap Accessible",
    label: "Handicap Accessible",
  },
  {
    value: "Jacuzzi Spa",
    label: "Jacuzzi Spa",
  },
  {
    value: "Pool House/ Art Studio",
    label: "Pool House/ Art Studio",
  },
];
const natureOfPartyOptions = [
  {
    value: "Family",
    label: "Family",
  },
  {
    value: "A Few Friend",
    label: "A Few Friend",
  },
  {
    value: "Larger Group",
    label: "Larger Group",
  },
  {
    value: "Mature Couple",
    label: "Mature Couple",
  },
];
const propertyTypeOptions = [
  {
    value: "Residential",
    label: "Residential",
  },
  {
    value: "Commercial",
    label: "Commercial",
  },
  // {
  //   value: "Land",
  //   label: "Land",
  // },
  // {
  //   value: "Open House",
  //   label: "Open House",
  // },
  // {
  //   value: "Ranch",
  //   label: "Ranch",
  // },
];
const propertyTypeCommercialOptions = [
  {
    value: "Resturant/Club",
    label: "Resturant/Club",
  },
  {
    value: "Retail",
    label: "Retail",
  },
  {
    value: "Office",
    label: "Office",
  },
  {
    value: "Industrial",
    label: "Industrial",
  },
  {
    value: "Hotels-motel",
    label: "Hotels-motel",
  },
  {
    value: "Agriculture",
    label: "Agriculture",
  },
];

const timeFrameOptions = [
  {
    value: "ASAP",
    label: "ASAP",
  },
  {
    value: "Within Next Mon",
    label: "Within Next Mon",
  },
  {
    value: "3-6 Months",
    label: "3-6 Months",
  },
];
const listKeyOptions = [
  {
    value: "At Rosehip",
    label: "At Rosehip",
  },
  {
    value: "On Site",
    label: "On Site",
  },
  {
    value: "Call",
    label: "Call",
  },
  // {
  //   value: "N/A",
  //   label: "N/A",
  // },
];
const rentalPeriodOptions = [
  {
    RentalPeriod: "MD-LD",
  },
  {
    RentalPeriod: "May",
  },
  {
    RentalPeriod: "June",
  },
  {
    RentalPeriod: "June/July",
  },
  {
    RentalPeriod: "July",
  },
  {
    RentalPeriod: "July - LD",
  },
  {
    RentalPeriod: "August",
  },
  {
    RentalPeriod: "August - LD",
  },
  {
    RentalPeriod: "September",
  },
  {
    RentalPeriod: "October",
  },
  {
    RentalPeriod: "November",
  },
  {
    RentalPeriod: "December",
  },
  {
    RentalPeriod: "January",
  },
  {
    RentalPeriod: "February",
  },
  {
    RentalPeriod: "March",
  },
  {
    RentalPeriod: "April",
  },
  {
    RentalPeriod: "Year Round",
  },
  {
    RentalPeriod: "Winter",
  },
  

];

const priceOptions = [
  {
    value: "0-2500",
    label: "0-2500",
  },
  {
    value: "2500-5000",
    label: "2500-5000",
  },
  {
    value: "5000-7500",
    label: "5000-7500",
  },
  {
    value: "7500-10000",
    label: "7500-10000",
  },
  {
    value: "10000-15000",
    label: "10000-15000",
  },
  {
    value: "15000-20000",
    label: "15000-20000",
  },
  {
    value: "20000-25000",
    label: "20000-25000",
  },
  {
    value: "25000-30000",
    label: "25000-30000",
  },
  {
    value: "30000-35000",
    label: "30000-35000",
  },
  {
    value: "35000-40000",
    label: "35000-40000",
  },
  {
    value: "40000-45000",
    label: "40000-45000",
  },
  {
    value: "45000-50000",
    label: "45000-50000",
  },
  {
    value: "50000-55000",
    label: "50000-55000",
  },
  {
    value: "55000-60000",
    label: "55000-60000",
  },
  {
    value: "60000-65000",
    label: "60000-65000",
  },
  {
    value: "65000-70000",
    label: "65000-70000",
  },
  {
    value: "70000-75000",
    label: "70000-75000",
  },
  {
    value: "75000-80000",
    label: "75000-80000",
  },
  {
    value: "80000-85000",
    label: "80000-85000",
  },
  {
    value: "85000-90000",
    label: "85000-90000",
  },
  {
    value: "90000-95000",
    label: "90000-95000",
  },
  {
    value: "95000-100000",
    label: "95000-100000",
  },
  {
    value: "100000-110000",
    label: "100000-110000",
  },
  
  {
    value: "110000-120000",
    label: "110000-120000",
  },
  {
    value: "120000-130000",
    label: "120000-130000",
  },
  {
    value: "130000-140000",
    label: "130000-140000",
  },
  {
    value: "140000-150000",
    label: "140000-150000",
  },
];
const keywordOptions = [
  {
    value: "Waterfront Living",
    label: "Waterfront Living",
  },
  {
    value: "Poolside Picks",
    label: "Poolside Picks",
  },
  {
    value: "Beach Side Living",
    label: "Beach Side Living",
  },
  {
    value: "Rent in Mountak",
    label: "Rent in Mountak",
  },
];
const amenities = [
  {
  value : "Charming",
  label : "Charming",
},
{
  value : "Convenient",
  label : "Convenient",
},
{
  value : "Jacuzzi Spa",
  label : "Jacuzzi Spa",
},
{
  value : "Pool House/ Art Studio",
  label : "Pool House/ Art Studio",
},
{
  value : "South-of Highway",
  label : "South-of Highway",
},
{
  value : "Near to beach",
  label : "Near to beach",
},
{
  value : "Wireless Web",
  label : "Wireless Web",
},
{
  value : "Child Safety Fence",
  label : "Child Safety Fence",
},
{
  value : "Downstairs Master",
  label : "Downstairs Master",
},
{
  value : "New Construction",
  label : "CharNew Constructionming",
},
{
  value : "Quiet",
  label : "Quiet",
},
{
  value : "Village Location",
  label : "Village Location",
},
{
  value : "Near to village",
  label : "Near to village",
}
] 
const sqFeet = [{
  value : "0-1000",
  label : "0-1000"
},
{
  value : "1000-2000",
  label : "1000-2000"
},
{
  value : "2000-3000",
  label : "2000-3000"
},
{
  value : "3000-4000",
  label : "3000-4000"
},
{
  value : "4000-5000",
  label : "4000-5000"
},
{
  value : "5000-6000",
  label : "5000-6000"
},
{
  value : "6000-7000",
  label : "6000-7000"
},
{
  value : "7000-8000",
  label : "7000-8000"
},
{
  value : "8000-9000",
  label : "8000-9000"
},
{
  value : "9000-10000",
  label : "9000-10000"
},
{
  value : ">10000",
  label : ">10000"
},
]
const agreementDatas =
  "<p>THIS IS NOT A CONTRACT\n\nNew York State law requires real estate licensees who are acting as agents of landlords and tenants of real property to advise the potential landlords and tenants with whom they work of the nature of their agency relationship and the rights and obligations it creates. This disclosure will help you to make informed choices about your relationship with the real estate broker and its sales associates.\n\nThroughout the transaction you may receive more than one disclosure form. The law requires each agent assisting in the transaction to present you with this disclosure form. A real estate agent is a person qualified to advise about real estate.\nIf you need legal, tax or other advice, consult with a professional in that field.\n\nDisclosure Regarding Real Estate Agency Relationships\n\nLandlord's Agent\nA landlord's agent is an agent who is engaged by a landlord to represent the landlord's interest. The landlord's agent does this by securing a tenant for the landlord's apartment or house at a rent and on terms acceptable to the landlord. A landlord's agent has, without limitation, the following fiduciary duties to the landlord: reasonable care, undivided loyalty, confidentiality, full disclosure, obedience and duty to account. A landlord's agent does not represent the interests of the tenant. The obligations of a landlord's agent are also subject to any specific provisions set forth in an agreement between the agent and the landlord. In dealings with the tenant, a landlord's agent should (a) exercise reasonable skill and care in performance of the agent's duties; (b) deal honestly, fairly and in good faith; and (c) disclose all facts known to the agent materially affecting the value or desirability of property, except as otherwise provided by law.\n\nTenant's Agent\nA tenant's agent is an agent who is engaged by a tenant to represent the tenant's interest. The tenant's agent does this by negotiating the rental or lease of an apartment or house at a rent and on terms acceptable to the tenant. A tenant's agent has, without limitation, the following fiduciary duties to the tenant: reasonable care, undivided loyalty, confidentiality, full disclosure, obedience and duty to account. A tenant's agent does not represent the interest of the landlord. The obligations of a tenant's agent are also subject to any specific provisions set forth in an agreement between the agent and the tenant. In dealings with the landlord, a tenants agent should (a) exercise reasonable skill and care in performance of the agent's duties; (b) deal honestly, fairly and in good faith; and (c) disclose all facts known to the tenants ability and/or willingness to perform a contract to rent or lease landlord's property that are not consistent with the agent's fiduciary duties to the buyer.\n\nBroker's Agents\nA broker's agent is an agent that cooperates or is engaged by a listing agent or a tenant's agent (but does not work for the same firm as the listing agent or tenant's agent) to assist the listing agent or tenant's agent in locating a property to rent or lease for the listing agent's landlord or the tenant agent's tenant. The broker's agent does not have a direct relationship with the tenant or landlord and the tenant or landlord can not provide instructions or direction directly to the broker's agent. The tenant and the landlord therefore do not have vicarious liability for the acts of the broker's agent. The listing agent or tenant's agent do provide direction and instruction to the broker's agent and therefore the listing agent or tenant's agent will have liability for the acts of the broker's agent.\n\nDual Agent\nA real estate broker may represent both the tenant and the landlord if both the tenant and landlord give their informed consent in writing. In such a dual agency situation, the agent will not be able to provide the full range of fiduciary duties to the landlord and the tenant. The obligations of an agent are also subject to any specific provisions set forth in an agreement between the agent, and the tenant and landlord. An agent acting as a dual agent must explain carefully to both the landlord and tenant that the agent is acting for the other party as well. The agent should also explain the possible effects of dual representation, including that by consenting to the dual agency relationship the landlord and tenant are giving up their right to undivided loyalty. A landlord and tenant should carefully consider the possible consequences of a dual agency relationship before agreeing to such representation\n\nDual Agent with Designated Sales Agents\nIf the tenant and the landlord provide their informed consent in writing, the principals and the real estate broker who represents both parties as a dual agent may designate a sales agent to represent the tenant and another sales agent to represent the landlord. A sales agent works under the supervision of the real estate broker. With the informed consent in writing of the tenant and the landlord, the designated sales agent for the tenant will function as the tenant's agent representing the interests of and advocating on behalf of the tenant and the designated sales agent for the landlord will function as the landlord's agent representing the interests of and advocating on behalf of the landlord in the negotiations between the tenant and the landlord. A designated sales agent cannot provide the full range of fiduciary duties to the landlord or tenant. The designated sales agent must explain that like the dual agent under whose supervision they function, they cannot provide undivided loyalty. A landlord or tenant should carefully consider the possible consequences of a dual agency relationship with designated sales agents before agreeing to such representation.</p>";
 
export {
  waterfrontOptions,
  homeAreaOptions,
  tennisOptions,
  styleOptions,
  storyOptions,
  amenities,
  poolOptions,
  sqFeet,
  petsOptions,
  heatingOptions,
  garageOptions,
  fireplaceOptions,
  bedRoomsOptions,
  ACOptions,
  bathroomOptions,
  basementOptions,
  areaOptions,
  subAreaOptions,
  leaseTermOptions,
  mainAmenityOptions,
  natureOfPartyOptions,
  propertyTypeOptions,
  propertyTypeCommercialOptions,
  timeFrameOptions,
  listKeyOptions,
  agreementDatas,
  rentalPeriodOptions,
  priceOptions,
  keywordOptions
};
